import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import { v4 } from 'node-uuid';
import StarRating from 'common/components/star_rating';
import { MAX_COMMENT_LENGTH } from 'focus_groups/constants';

export default class VoteBar extends Component {
  constructor(props) {
    super(props);

    this.onChangeComment = this.onChangeComment.bind(this);
    this.onVote = this.onVote.bind(this);
  }

  onChangeComment(e) {
    this.props.setComment(e.target.value);
  }

  onVote() {
    const {
      vote, id, currentRevisionIndex, totalRevisions, currentComment, currentRating,
      votes, params, toggleVoting, setVoteIndex, fetchGroup
    } = this.props;
    const score = idx(votes, _ => _[params.participantId].score);
    const comment = idx(votes, _ => _[params.participantId].comment);
    const isLast = currentRevisionIndex + 1 === totalRevisions;
    const data = {
      score: currentRating || score,
      comment: currentComment === null? comment || '' : currentComment
    };

    vote(id, data).then(() => {
      fetchGroup();
      if (isLast) {
        toggleVoting();
      }
      setVoteIndex(isLast? null : currentRevisionIndex + 1);
    })
  }

  render() {
    const {
      id, currentComment, currentRevisionIndex, totalRevisions,
      currentRating, setRating, previous, votes, params,
    } = this.props;

    const score = idx(votes, _ => _[params.participantId].score);
    const comment = idx(votes, _ => _[params.participantId].comment);
    const hasRating = !!currentRating || !!score;
    const valid = (currentComment || '').length <= MAX_COMMENT_LENGTH;

    return (
      <div className="vote-bar">
        <div className="row columns text-center">
          #{currentRevisionIndex + 1} of {totalRevisions}
        </div>
        <div className="row columns rating text-center">
          <StarRating key={v4()} initialRate={currentRating || score || 0}
            onChange={setRating} extraClasses="lg"/>
        </div>
        <div className="row align-middle">
          <div className="columns small-16 medium-8 medium-order-2">
            <textarea
              key={id}
              value={currentComment === null? comment || '' : currentComment}
              onChange={this.onChangeComment}
              placeholder="Comment on this design..."
              className="form-control"
              rows={3}
            />
            { !valid &&
            <span className="error-msg text-danger">
              No more than { MAX_COMMENT_LENGTH } characters are allowed.
            </span> }
          </div>
          <div className="columns small-8 medium-4 medium-order-1">
            {currentRevisionIndex !== 0 && <button className="btn btn-text btn-with-icon" onClick={previous}>
              <i className="fa fa-angle-left" />
              Previous
            </button>}
          </div>
          <div className="columns small-8 medium-4 medium-order-3 text-right">
            { hasRating && valid && <button className="btn btn-primary" onClick={this.onVote}>
              Next
            </button> }
          </div>
        </div>
      </div>
    );
  }
}

VoteBar.propTypes = {
  previous: PropTypes.func.isRequired,
  vote: PropTypes.func.isRequired,
  setRating: PropTypes.func.isRequired,
  setComment: PropTypes.func.isRequired,
  toggleVoting: PropTypes.func.isRequired,
  setVoteIndex: PropTypes.func.isRequired,
  fetchGroup: PropTypes.func.isRequired,

  totalRevisions: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,

  currentRevisionIndex: PropTypes.number,
  currentComment: PropTypes.string,
  currentRating: PropTypes.any,
  votes: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/vote_bar.jsx